import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4285F4",
      d: "M14 8.636q-.002-.638-.111-1.227H8.122v2.324h3.295a2.77 2.77 0 0 1-1.23 1.805v1.511h1.987C13.332 12.002 14 10.464 14 8.636"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#34A853",
      d: "M8.122 14.5c1.654 0 3.04-.534 4.052-1.45l-1.987-1.512c-.545.36-1.24.578-2.065.578-1.591 0-2.944-1.052-3.428-2.47H2.657v1.548A6.13 6.13 0 0 0 8.122 14.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FBBC05",
      d: "M4.694 9.64a3.5 3.5 0 0 1-.195-1.14c0-.398.072-.78.195-1.14V5.81H2.657a5.83 5.83 0 0 0 0 5.38l1.586-1.212z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#EA4335",
      d: "M8.122 4.89c.902 0 1.704.305 2.344.894l1.753-1.719C11.156 3.095 9.776 2.5 8.122 2.5a6.13 6.13 0 0 0-5.465 3.31l2.037 1.55c.484-1.418 1.837-2.47 3.428-2.47"
    }, null, -1)
  ])))
}
export default { render: render }